import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const bscTestnet: VToken[] = [
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0x08e0A5575De71037aE36AbfAfb516595fE68e5e4',
    decimals: 8,
    symbol: 'vBUSD',
    underlyingToken: tokens[97][7],
  },
  {
    chainId: 97,
    address: '0x74469281310195A04840Daf6EdF576F559a3dE80',
    decimals: 8,
    symbol: 'vSXP',
    underlyingToken: tokens[97][4],
  },
  {
    chainId: 97,
    address: '0x2E7222e51c0f6e98610A1543Aa3836E092CDe62c',
    decimals: 8,
    symbol: 'vBNB',
    underlyingToken: tokens[97][0],
  },
  {
    chainId: 97,
    address: '0x6d6F697e34145Bb95c54E77482d97cc261Dc237E',
    decimals: 8,
    symbol: 'Venus XVS',
    underlyingToken: tokens[97][1],
  },
  {
    chainId: 97,
    address: '0x162D005F0Fff510E54958Cfc5CF32A3180A84aab',
    decimals: 8,
    symbol: 'vETH',
    underlyingToken: tokens[97][9],
  },
  {
    chainId: 97,
    address: '0xAfc13BC065ABeE838540823431055D2ea52eBA52',
    decimals: 8,
    symbol: 'vLTC',
    underlyingToken: tokens[97][10],
  },
  {
    chainId: 97,
    address: '0x488aB2826a154da01CC4CC16A8C83d4720D3cA2C',
    decimals: 8,
    symbol: 'vXRP',
    underlyingToken: tokens[97][11],
  },
  {
    chainId: 97,
    address: '0xb6e9322C49FD75a367Fcb17B0Fcd62C5070EbCBe',
    decimals: 8,
    symbol: 'vBTC',
    underlyingToken: tokens[97][8],
  },
  {
    chainId: 97,
    address: '0x37C28DE42bA3d22217995D146FC684B2326Ede64',
    decimals: 8,
    symbol: 'vADA',
    underlyingToken: tokens[97][12],
  },
  {
    chainId: 97,
    address: '0xF912d3001CAf6DC4ADD366A62Cc9115B4303c9A9',
    decimals: 8,
    symbol: 'vDOGE',
    underlyingToken: tokens[97][13],
  },
  {
    chainId: 97,
    address: '0xeDaC03D29ff74b5fDc0CC936F6288312e1459BC6',
    decimals: 8,
    symbol: 'vCAKE',
    underlyingToken: tokens[97][15],
  },
  {
    chainId: 97,
    address: '0x3619bdDc61189F33365CC572DF3a68FB3b316516',
    decimals: 8,
    symbol: 'vMATIC',
    underlyingToken: tokens[97][14],
  },
  {
    chainId: 97,
    address: '0x714db6c38A17883964B68a07d56cE331501d9eb6',
    decimals: 8,
    symbol: 'vAAVE',
    underlyingToken: tokens[97][16],
  },
  {
    chainId: 97,
    address: '0x3A00d9B02781f47d033BAd62edc55fBF8D083Fb0',
    decimals: 8,
    symbol: 'vTUSDOLD',
    underlyingToken: tokens[97][18],
  },
  {
    chainId: 97,
    address: '0x369Fea97f6fB7510755DCA389088d9E2e2819278',
    decimals: 8,
    symbol: 'vTRXOLD',
    underlyingToken: tokens[97][20],
  },
  {
    chainId: 97,
    address: '0x6AF3Fdb3282c5bb6926269Db10837fa8Aec67C04',
    decimals: 8,
    symbol: 'vTRX',
    underlyingToken: tokens[97][19],
  },
  {
    chainId: 97,
    address: '0x35566ED3AF9E537Be487C98b1811cDf95ad0C32b',
    decimals: 8,
    symbol: 'vWBETH',
    underlyingToken: tokens[97][37],
  },
  {
    chainId: 97,
    address: '0xEFAACF73CE2D38ED40991f29E72B12C74bd4cf23',
    decimals: 8,
    symbol: 'vTUSD',
    underlyingToken: tokens[97][17],
  },
  {
    chainId: 97,
    address: '0x171B468b52d7027F12cEF90cd065d6776a25E24e',
    decimals: 8,
    symbol: 'vUNI',
    underlyingToken: tokens[97][44],
  },
  {
    chainId: 97,
    address: '0xF06e662a00796c122AaAE935EC4F0Be3F74f5636',
    decimals: 8,
    symbol: 'vFDUSD',
    underlyingToken: tokens[97][46],
  },
  {
    chainId: 97,
    address: '0xA38110ae4451A86ab754695057d5B5a9BEAd0387',
    decimals: 8,
    symbol: 'vSolvBTC',
    underlyingToken: tokens[97][50],
  },
  {
    chainId: 97,
    address: '0x95DaED37fdD3F557b3A5cCEb7D50Be65b36721DF',
    decimals: 8,
    symbol: 'vTWT',
    underlyingToken: tokens[97][39],
  },
  {
    chainId: 97,
    address: '0x39A239F5117BFaC7a1b0b3A517c454113323451d',
    decimals: 8,
    symbol: 'vTHE',
    underlyingToken: tokens[97][40],
  },
  {
    chainId: 97,
    address: '0xbd9EB061444665Df7282Ec0888b72D60aC41Eb8C',
    decimals: 8,
    symbol: 'vSOL',
    underlyingToken: tokens[97][52],
  },
  {
    chainId: 97,
    address: '0x9447b1D4Bd192f25416B6aCc3B7f06be2f7D6309',
    decimals: 8,
    symbol: 'vlisUSD',
    underlyingToken: tokens[97][29],
  },
  {
    chainId: 97,
    address: '0x90535B06ddB00453a5e5f2bC094d498F1cc86032',
    decimals: 8,
    symbol: 'vPT-sUSDE-26JUN2025',
    underlyingToken: tokens[97][55],
  },
  {
    chainId: 97,
    address: '0x8c8A1a0b6e1cb8058037F7bF24de6b79Aca5B7B0',
    decimals: 8,
    symbol: 'vsUSDe',
    underlyingToken: tokens[97][57],
  },
  {
    chainId: 97,
    address: '0x86f8DfB7CA84455174EE9C3edd94867b51Da46BD',
    decimals: 8,
    symbol: 'vUSDe',
    underlyingToken: tokens[97][56],
  },
  {
    chainId: 97,
    address: '0x519e61D2CDA04184FB086bbD2322C1bfEa0917Cf',
    decimals: 8,
    symbol: 'vUSD1',
    underlyingToken: tokens[97][58],
  },
  {
    chainId: 97,
    address: '0x97cB97B05697c377C0bd09feDce67DBd86B7aB1e',
    decimals: 8,
    symbol: 'vxSolvBTC',
    underlyingToken: tokens[97][59],
  },
  {
    chainId: 97,
    address: '0x73F506Aefd5e169D48Ea21A373B9B0a200E37585',
    decimals: 8,
    symbol: 'vasBNB',
    underlyingToken: tokens[97][54],
  },
  {
    chainId: 97,
    address: '0x140d5Da2cE9fb9A8725cabdDB2Fe8ea831342C78',
    decimals: 8,
    symbol: 'vUSDF',
    underlyingToken: tokens[97][60],
  },
  {
    chainId: 97,
    address: '0xd9E77847ec815E56ae2B9E69596C69b6972b0B1C',
    decimals: 8,
    symbol: 'vWBNB',
    underlyingToken: tokens[97][34],
  },
  {
    chainId: 97,
    address: '0xaB5504A3cde0d8253E8F981D663c7Ff7128B3e56',
    decimals: 8,
    symbol: 'vslisBNB',
    underlyingToken: tokens[97][41],
  },
  {
    chainId: 97,
    address: '0x93969F17d4c1C7B22000eA26D5C2766E0f616D90',
    decimals: 8,
    symbol: 'vU',
    underlyingToken: tokens[97][62],
  },
  {
    chainId: 97,
    address: '0xCd5A0037ebfC4a22A755923bB5C983947FaBdCe7',
    decimals: 8,
    symbol: 'vPT-clisBNB-25JUN2026',
    underlyingToken: tokens[97][63],
  },
  {
    chainId: 97,
    address: '0xc93CBF6CA7F3124737F2f4daDa8dBBC7be56d125',
    decimals: 8,
    symbol: 'vXAUM',
    underlyingToken: tokens[97][64],
  },
  {
    chainId: 97,
    address: '0x3Ed56f6937fc8549f9325405d1e8E650739647Fa',
    decimals: 8,
    symbol: 'vTSLAB',
    underlyingToken: tokens[97][67],
  },
  {
    chainId: 97,
    address: '0x9e1ECb2671AfabE9eaAA2e74Cb2318a9b6A2Eb5d',
    decimals: 8,
    symbol: 'vNVDAB',
    underlyingToken: tokens[97][68],
  },
  {
    chainId: 97,
    address: '0x05B2EC5B7437FB188175bf440e3EB36af79fe319',
    decimals: 8,
    symbol: 'vSPCXB',
    underlyingToken: tokens[97][69],
  },
  {
    chainId: 97,
    address: '0x101843eAbA6b98fbF4bba078b86EFdE62DF0fc16',
    decimals: 8,
    symbol: 'vSKHYB',
    underlyingToken: tokens[97][70],
  },
  {
    chainId: 97,
    address: '0xb846eEbaC8b014296709dc660Bfcb6ea182718e8',
    decimals: 8,
    symbol: 'vvSHARE',
    underlyingToken: tokens[97][73],
  },
  {
    chainId: 97,
    address: '0xc9cc8D6F8dE76943B8f34C8aA730A0e892322f28',
    decimals: 8,
    symbol: 'vvhTUSD',
    underlyingToken: tokens[97][74],
  },
  {
    chainId: 97,
    address: '0xa7CB7C1cf9C31fC077Fd7c6dEa30119Bec796f1D',
    decimals: 8,
    symbol: 'vvhTUSD',
    underlyingToken: tokens[97][74],
  },
  {
    chainId: 97,
    address: '0x86f8DfB7CA84455174EE9C3edd94867b51Da46BD',
    decimals: 8,
    symbol: 'vUSDe',
    underlyingToken: tokens[97][56],
  },
  {
    chainId: 97,
    address: '0x8c8A1a0b6e1cb8058037F7bF24de6b79Aca5B7B0',
    decimals: 8,
    symbol: 'vsUSDe',
    underlyingToken: tokens[97][57],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0xb6e9322C49FD75a367Fcb17B0Fcd62C5070EbCBe',
    decimals: 8,
    symbol: 'vBTC',
    underlyingToken: tokens[97][8],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xb6e9322C49FD75a367Fcb17B0Fcd62C5070EbCBe',
    decimals: 8,
    symbol: 'vBTC',
    underlyingToken: tokens[97][8],
  },
  {
    chainId: 97,
    address: '0xA38110ae4451A86ab754695057d5B5a9BEAd0387',
    decimals: 8,
    symbol: 'vSolvBTC',
    underlyingToken: tokens[97][50],
  },
  {
    chainId: 97,
    address: '0x97cB97B05697c377C0bd09feDce67DBd86B7aB1e',
    decimals: 8,
    symbol: 'vxSolvBTC',
    underlyingToken: tokens[97][59],
  },
  {
    chainId: 97,
    address: '0xd9E77847ec815E56ae2B9E69596C69b6972b0B1C',
    decimals: 8,
    symbol: 'vWBNB',
    underlyingToken: tokens[97][34],
  },
  {
    chainId: 97,
    address: '0x73F506Aefd5e169D48Ea21A373B9B0a200E37585',
    decimals: 8,
    symbol: 'vasBNB',
    underlyingToken: tokens[97][54],
  },
  {
    chainId: 97,
    address: '0xaB5504A3cde0d8253E8F981D663c7Ff7128B3e56',
    decimals: 8,
    symbol: 'vslisBNB',
    underlyingToken: tokens[97][41],
  },
  {
    chainId: 97,
    address: '0xCd5A0037ebfC4a22A755923bB5C983947FaBdCe7',
    decimals: 8,
    symbol: 'vPT-clisBNB-25JUN2026',
    underlyingToken: tokens[97][63],
  },
  {
    chainId: 97,
    address: '0x171B468b52d7027F12cEF90cd065d6776a25E24e',
    decimals: 8,
    symbol: 'vUNI',
    underlyingToken: tokens[97][44],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0x714db6c38A17883964B68a07d56cE331501d9eb6',
    decimals: 8,
    symbol: 'vAAVE',
    underlyingToken: tokens[97][16],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0xF912d3001CAf6DC4ADD366A62Cc9115B4303c9A9',
    decimals: 8,
    symbol: 'vDOGE',
    underlyingToken: tokens[97][13],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0x95DaED37fdD3F557b3A5cCEb7D50Be65b36721DF',
    decimals: 8,
    symbol: 'vTWT',
    underlyingToken: tokens[97][39],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0x37C28DE42bA3d22217995D146FC684B2326Ede64',
    decimals: 8,
    symbol: 'vADA',
    underlyingToken: tokens[97][12],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0xAfc13BC065ABeE838540823431055D2ea52eBA52',
    decimals: 8,
    symbol: 'vLTC',
    underlyingToken: tokens[97][10],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0x6AF3Fdb3282c5bb6926269Db10837fa8Aec67C04',
    decimals: 8,
    symbol: 'vTRX',
    underlyingToken: tokens[97][19],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0x39A239F5117BFaC7a1b0b3A517c454113323451d',
    decimals: 8,
    symbol: 'vTHE',
    underlyingToken: tokens[97][40],
  },
  {
    chainId: 97,
    address: '0xb7526572FFE56AB9D7489838Bf2E18e3323b441A',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5C4C2e2facBEB59D0216D0595d63FcDc6F9A1a7',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[97][5],
  },
  {
    chainId: 97,
    address: '0x170d3b2da05cc2124334240fB34ad1359e34C562',
    decimals: 8,
    symbol: 'vlisUSD_Stablecoins',
    underlyingToken: tokens[97][29],
  },
  {
    chainId: 97,
    address: '0x3338988d0beb4419Acb8fE624218754053362D06',
    decimals: 8,
    symbol: 'vUSDT_StableCoins',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0x899dDf81DfbbF5889a16D075c352F2b959Dd24A4',
    decimals: 8,
    symbol: 'vUSDD_StableCoins',
    underlyingToken: tokens[97][33],
  },
  {
    chainId: 97,
    address: '0x4E1D35166776825402d50AfE4286c500027211D1',
    decimals: 8,
    symbol: 'vEURA_Stablecoins',
    underlyingToken: tokens[97][42],
  },
  {
    chainId: 97,
    address: '0xe507B30C41E9e375BCe05197c1e09fc9ee40c0f6',
    decimals: 8,
    symbol: 'vankrBNB_DeFi',
    underlyingToken: tokens[97][23],
  },
  {
    chainId: 97,
    address: '0x5e68913fbbfb91af30366ab1B21324410b49a308',
    decimals: 8,
    symbol: 'vBSW_DeFi',
    underlyingToken: tokens[97][26],
  },
  {
    chainId: 97,
    address: '0xb7caC5Ef82cb7f9197ee184779bdc52c5490C02a',
    decimals: 8,
    symbol: 'vALPACA_DeFi',
    underlyingToken: tokens[97][21],
  },
  {
    chainId: 97,
    address: '0x80CC30811e362aC9aB857C3d7875CbcCc0b65750',
    decimals: 8,
    symbol: 'vUSDT_DeFi',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xa109DE0abaeefC521Ec29D89eA42E64F37A6882E',
    decimals: 8,
    symbol: 'vUSDD_DeFi',
    underlyingToken: tokens[97][33],
  },
  {
    chainId: 97,
    address: '0xb677e080148368EeeE70fA3865d07E92c6500174',
    decimals: 8,
    symbol: 'vANKR_DeFi',
    underlyingToken: tokens[97][22],
  },
  {
    chainId: 97,
    address: '0x4C94e67d239aD585275Fdd3246Ab82c8a2668564',
    decimals: 8,
    symbol: 'vTWT_DeFi',
    underlyingToken: tokens[97][39],
  },
  {
    chainId: 97,
    address: '0xe237aA131E7B004aC88CB808Fa56AF3dc4C408f1',
    decimals: 8,
    symbol: 'vPLANET_DeFi',
    underlyingToken: tokens[97][45],
  },
  {
    chainId: 97,
    address: '0x1958035231E125830bA5d17D168cEa07Bb42184a',
    decimals: 8,
    symbol: 'vRACA_GameFi',
    underlyingToken: tokens[97][31],
  },
  {
    chainId: 97,
    address: '0xef470AbC365F88e4582D8027172a392C473A5B53',
    decimals: 8,
    symbol: 'vFLOKI_GameFi',
    underlyingToken: tokens[97][28],
  },
  {
    chainId: 97,
    address: '0x0bFE4e0B8A2a096A27e5B18b078d25be57C08634',
    decimals: 8,
    symbol: 'vUSDT_GameFi',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xdeDf3B2bcF25d0023115fd71a0F8221C91C92B1a',
    decimals: 8,
    symbol: 'vUSDD_GameFi',
    underlyingToken: tokens[97][33],
  },
  {
    chainId: 97,
    address: '0x57a664Dd7f1dE19545fEE9c86C949e3BF43d6D47',
    decimals: 8,
    symbol: 'vankrBNB_LiquidStakedBNB',
    underlyingToken: tokens[97][23],
  },
  {
    chainId: 97,
    address: '0x644A149853E5507AdF3e682218b8AC86cdD62951',
    decimals: 8,
    symbol: 'vBNBx_LiquidStakedBNB',
    underlyingToken: tokens[97][25],
  },
  {
    chainId: 97,
    address: '0x75aa42c832a8911B77219DbeBABBB40040d16987',
    decimals: 8,
    symbol: 'vstkBNB_LiquidStakedBNB',
    underlyingToken: tokens[97][32],
  },
  {
    chainId: 97,
    address: '0x231dED0Dfc99634e52EE1a1329586bc970d773b3',
    decimals: 8,
    symbol: 'vWBNB_LiquidStakedBNB',
    underlyingToken: tokens[97][34],
  },
  {
    chainId: 97,
    address: '0x2197d02cC9cd1ad51317A0a85A656a0c82383A7c',
    decimals: 8,
    symbol: 'vUSDT_LiquidStakedBNB',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD5b20708d8f0FcA52cb609938D0594C4e32E5DaD',
    decimals: 8,
    symbol: 'vUSDD_LiquidStakedBNB',
    underlyingToken: tokens[97][33],
  },
  {
    chainId: 97,
    address: '0xeffE7874C345aE877c1D893cd5160DDD359b24dA',
    decimals: 8,
    symbol: 'vslisBNB_LiquidStakedBNB',
    underlyingToken: tokens[97][41],
  },
  {
    chainId: 97,
    address: '0x7C4890D673985CE22A4D38761473f190e434c956',
    decimals: 8,
    symbol: 'vPT-clisBNB-24APR2025_LiquidStakedBNB',
    underlyingToken: tokens[97][53],
  },
  {
    chainId: 97,
    address: '0xc9D979AA6F3bE732A53a27188D74e929FD107187',
    decimals: 8,
    symbol: 'vasBNB_LiquidStakedBNB',
    underlyingToken: tokens[97][54],
  },
  {
    chainId: 97,
    address: '0x47793540757c6E6D84155B33cd8D9535CFdb9334',
    decimals: 8,
    symbol: 'vBTT_Tron',
    underlyingToken: tokens[97][27],
  },
  {
    chainId: 97,
    address: '0xEe543D5de2Dbb5b07675Fc72831A2f1812428393',
    decimals: 8,
    symbol: 'vWIN_Tron',
    underlyingToken: tokens[97][35],
  },
  {
    chainId: 97,
    address: '0x410286c43a525E1DCC7468a9B091C111C8324cd1',
    decimals: 8,
    symbol: 'vTRX_Tron',
    underlyingToken: tokens[97][19],
  },
  {
    chainId: 97,
    address: '0x712774CBFFCBD60e9825871CcEFF2F917442b2c3',
    decimals: 8,
    symbol: 'vUSDT_Tron',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0xD804F74fe21290d213c46610ab171f7c2EeEBDE7',
    decimals: 8,
    symbol: 'vUSDD_Tron',
    underlyingToken: tokens[97][33],
  },
  {
    chainId: 97,
    address: '0x73d2F6e0708599a4eA70F6A0c55A4C59196a101c',
    decimals: 8,
    symbol: 'vBabyDoge_Meme',
    underlyingToken: tokens[97][47],
  },
  {
    chainId: 97,
    address: '0x3AF2bE7AbEF0f840b196D99d79F4B803a5dB14a1',
    decimals: 8,
    symbol: 'vUSDT_Meme',
    underlyingToken: tokens[97][6],
  },
  {
    chainId: 97,
    address: '0x16eb5Ce6d186B49709dD588518CD545985096Ff5',
    decimals: 8,
    symbol: 'vwstETH_LiquidStakedETH',
    underlyingToken: tokens[97][49],
  },
  {
    chainId: 97,
    address: '0x4BD7EfB423f06fa033404FBd0935A2097918084d',
    decimals: 8,
    symbol: 'vweETH_LiquidStakedETH',
    underlyingToken: tokens[97][48],
  },
  {
    chainId: 97,
    address: '0x46D49adF48172d2e79d813A3f4F27aB61724B01e',
    decimals: 8,
    symbol: 'vETH_LiquidStakedETH',
    underlyingToken: tokens[97][9],
  },
  {
    chainId: 97,
    address: '0x138500e8502f32f004F79507143E4FaaCA03E26d',
    decimals: 8,
    symbol: 'vBTCB_BTC',
    underlyingToken: tokens[97][8],
  },
];
